import { HttpParams } from "@angular/common/http";
import { Component, OnInit, TemplateRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { AdminService } from "src/app/services/admin.service";
import { apiUrl } from "../../../global/global";
import * as CONSTANT from "src/app/services/constants";
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import swal from "sweetalert2";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { chatEnvironment } from "src/environments/chatEnvironment";

@Component({
  selector: "app-applicant-job",
  templateUrl: "./applicant-job.component.html",
  styleUrls: ["./applicant-job.component.css"]
})
export class ApplicantJobComponent implements OnInit {
  jobId;
  allData:any;
  viewCount:any;
  listingData:any=[];
  messageList:any=[];
  currentPage=1;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  // sorting
  totalCount: any;
  sortType: any;
  sortBy : string = ""
  orderBy: string = "2";
  search="";
  closeSearch:boolean = false;
  showError:boolean = false;
  isBlock:boolean = false;
  filterApplied:boolean = false;
  //modal box
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  isStatus;
  // form
  noteData;
  form: FormGroup;
  jobForm: FormGroup;
  page;
  firebaseUsers = chatEnvironment.users;
  firebaseMessage = chatEnvironment.messages;
  firebaseChats = chatEnvironment.chats;
  firebaseJobs = chatEnvironment.jobs;
  firebaseNotification = chatEnvironment.notifications;
  
  constructor(private modalService: BsModalService,public route: ActivatedRoute, private router: Router,private api: AdminService,private formBuilder: FormBuilder,private db: AngularFireDatabase, private afAuth: AngularFireAuth, private toastrService: ToastrService,) {
    this.form = this.formBuilder.group({
      id:[""],
      note:["", Validators.compose([Validators.minLength(3),Validators.maxLength(2000)])]
    })
    this.jobForm = this.formBuilder.group({
      id:[""],
      reason:["", Validators.compose([Validators.required,Validators.minLength(3),Validators.maxLength(2000)])],
      isBlocked:[""],
      isNotify:[""]
    })
   }

  ngOnInit(): void {
    this.jobId =  this.route.snapshot.paramMap.get("id");
    
    this.route.queryParams.subscribe(params => {
     this.page = params['page'];
  });
    this.getDetail();
    this.getData();
  }
  backToJob(){
    this.router.navigate(['jobs'], { queryParams:{ page: this.page } })
  }
  // detail
  getDetail(){
    this.api.getDatas(apiUrl._getJobs+"/"+this.jobId)
    .subscribe(async (res) => {
      this.allData = res.data 
    })
  }
  // detail
  getData(){
    let params = new HttpParams(); 
    params = params.append("id", this.jobId);
    params = params.append("skip", this.currentPage);
    params = params.append("limit", this.pagination.limit.toString());
    if (this.search != null && this.search != "") {
      params = params.append("search", this.search);
    }
    if (this.isStatus != null) {
      params = params.append("status", this.isStatus);
    }
    if (this.sortBy) {
      params = params.append("sortBy",this.sortBy.trim() ? this.sortBy.trim() : "");
      params = params.append("orderBy", this.orderBy == "ASC" ? "ASC" : "DESC");
    }
    this.api.getData(apiUrl._getJobsApplicant,params)
    .subscribe(async (res) => {
      this.pagination.totalItems = res.data.count; 
      this.totalCount = res.data.count; 
      this.viewCount = res.data.totalViewCount; 
      this.listingData = res.data.listing; 
    })
  }
  
  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getData();
  }
  searchFun() {  
    this.currentPage = 1;
    this.pagination.skip = 0; 
    this.closeSearch = true; 
    if( this.listingData.length > 0){
      this.getData(); 
    } 
    }
  clearSearch() {
    this.search= "";
    this.closeSearch = false;
    this.pagination.skip = 0; 
    localStorage.removeItem("type-redirect");
   
    // if( this.listingData.length > 0){
      this.getData(); 
    // } 
  }
  filterApply(event){
    console.log(event.target.value);
    if(event.target.value == "all"){
      this.isStatus =null
      this.filter()
    } else  if(event.target.value == 0){
      this.isStatus =0
      this.filter()
    } else if(event.target.value == 1){
      this.isStatus =1
      this.filter()
    } else if(event.target.value == 2){
      this.isStatus =2
      this.filter()
    } else if(event.target.value == 3){
      this.isStatus =3
      this.filter()
    }else if(event.target.value == 4){
      this.isStatus =4
      this.filter()
    }else if(event.target.value == 5){
      this.isStatus =5
      this.filter()
    } else{
      this.getData()
    }
  }
  filter(){ 
    if(this.isStatus !=null){
      this.filterApplied=true 
      this.pagination.skip = 0; 
      this.currentPage = 1;
      this.getData() 
    } else{
      this.getData() 
    }
} 
clearFilter(){
  if(this.isStatus ==null){
    this.pagination.skip = 0; 
    this.currentPage = 1;
    this.getData() 
  }
}
  //  sorting
  setOrderBy(column) {
    if( this.sortBy != column){
      this.sortBy = column;
      this.orderBy = "ASC";
    }
    else{
   if( this.orderBy == "ASC"){
      this.orderBy = "DESC";
    }
    else{
      this.orderBy = "ASC";
     }
    } 
    this.getData(); 
  } 

  redirectToSuggestion(){
    // this.router.navigateByUrl(`/jobs/suggested/${this.jobId}`);
    this.router.navigate(['/jobs/suggested/' + this.jobId], { queryParams:{ page: this.page } })
  }
  redirectToDetail(){
    // this.router.navigateByUrl(`/jobs/detail/${this.jobId}`);
    this.router.navigate(['/jobs/detail/' + this.jobId], { queryParams:{ page: this.page } })
  }
  
  // job status
  
jobOpenStatus(event,id){ 
  let text = "<p>Are you sure you want to Open this job?</p>"; 
  swal.fire({
    html: text,
    showCloseButton: false,
    showCancelButton: true,
    focusConfirm: false,
    confirmButtonColor: "#EF7E2B",
    cancelButtonColor: "#ffffff",
    confirmButtonText:"Yes",
    cancelButtonText: "No",
    reverseButtons: true,
    width: 500
}).then((result) => {
  if (result.value) { 
    const data = {
      "id": id, 
      "isBlocked": 0,  
    }
    this.api.putData(apiUrl._getJobs, data).subscribe(res => {
    this.getDetail();
  })
}
});
}
  status(event,data,number){ 
    let status;
    let userData =data;
    let text;
    if(number == 0){
      status = 0;
      text = "<p>Are you sure you want to change status as pending for this user?</p>";
    }else if(number ==1){
      status = 1;
      text = "<p>Are you sure you want to Shortlist this user?</p>";
    }else if(number ==2){
      status = 2;
      text = "<p>Are you sure you want to reject this user?</p>";
    }else if(number ==3){
      status = 3;
      text = "<p>Are you sure you want to ON HOLD this user?</p>";
    }else if(number ==4){
      status = 4;
      number =4;
      text = "<p>Are you sure you BV not cleared this user?</p>";
    }else{
      status = 5;
      number =5;
      text = "<p>Are you sure you Hired this user?</p>";
    }
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText:"Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
  }).then((result) => {
    if (result.value) { 
      const data = {
        "id": userData.id, 
        "userId": userData.userId, 
        "status": status,
        "jobPostId": userData.jobPostId 
      }
      this.api.putData(apiUrl._statusUpdate, data).subscribe(res => {
      this.getData();
    })
  }
  });
  }
  // job status
  openModal(allData,jobStatus: TemplateRef<any>) { 
    this.jobForm.patchValue({
      id:allData?.JobPost?.id,
      isBlocked:1,
    })
    this.modalRef = this.modalService.show(
      jobStatus,
      Object.assign({},this.config, { class: "modal-sm addModal" })
    ); 
  } 
  // job status
  jobPostStatus(){
    if(this.jobForm.valid){
      if(this.jobForm.value.isNotify == true){
        this.jobForm.patchValue({
          isNotify : 1
        })
      } else{
        this.jobForm.patchValue({
          isNotify : 0
        })
      }
      this.api.putData(apiUrl._statusReason, this.jobForm.value).subscribe(res => {
        this.modalRef?.hide()
        this.jobForm.reset()
        this.getData();
        this.getDetail();
      })  
    } else{
      this.showError= true
      setTimeout(() => {
        this.showError= false
      }, 1500);
    }
  }
  //notes model
  viewNoteStatus(event,data,viewNotes: TemplateRef<any>){
    this.noteData=data;
    this.modalRef = this.modalService.show(
      viewNotes,
      Object.assign({},this.config, { class: "modal-sm addModal" })
    );
  }
  //notes model
  noteStatus(event,data,addMore: TemplateRef<any>){
    this.noteData=data;
    
    this.modalRef = this.modalService.show(
      addMore,
      Object.assign({},this.config, { class: "modal-sm addModal" })
    );
  }
  onSubmit(){
    const data = {
      "id": this.noteData.id, 
      "userId": this.noteData.userId, 
      "note": this.form.value.note, 
      "status": this.noteData.status, 
    }
    this.api.putData(apiUrl._statusUpdate, data).subscribe(res => {
      this.modalRef?.hide();
      this.getData();
      this.getDetail();
  })
  }
  // redirect to
  redirectTo(data){
    if(this.viewCount > 0){
      let page= this.page 
      this.router.navigate([`/jobs/applicant/${data.jobPostId}/appdetail/`], {queryParams : { userId: `${data.userId}`, applicantId: `${data.id}`,page :page } });
    } else{
      this.toastrService.error("", "Your profile view count is 0 to see more applicant profile you need to buy the new plan.");
    }
  }
  openChatView(data){
    var job_id = data.jobPostId;
    var user_id = data.user?.id;
    var user_pic = data.user?.profileImage;
    var user_name = data.user?.name;
    var company_name = data.jobPosts?.recruiter.companyName;
    var company_pic = data.jobPosts?.recruiter.profileImage;
    var chatDiologId = data?.jobPostId+','+data.user?.id;
    /////////////////////////
    var userNameArr = {};
    userNameArr[job_id] = company_name;
    userNameArr[user_id] = data.user?.name;

    var blockStatus = {};
    blockStatus[job_id] = 0;
    blockStatus[user_id] = 0;

    let unread_count = {}
    unread_count[job_id] = 0;
    unread_count[user_id] = 0;

    var clearChatTime = {};
    clearChatTime[job_id] = new Date().getTime();
    clearChatTime[user_id] = new Date().getTime();

    //////////////////
    var lastMessageArr = {};
    lastMessageArr[job_id] = '';
    lastMessageArr[user_id] = '';

    var picArr = {};
    picArr[job_id] = company_pic;
    picArr[user_id] = data.user?.profileImage;
    /////////////////////////
    this.db.list(`${this.firebaseChats}`,
    query => query
        .orderByChild("chat_dialog_id")
        .equalTo(chatDiologId)
        .limitToLast(10)
    ).valueChanges().subscribe(list => {      
            this.messageList = list ? list : [];
            /////////////////////////////////////
            if (list.length == 0) {         
              var chatDialog = this.db.object(`${this.firebaseChats}/${chatDiologId}`).set({
                "chat_dialog_id": chatDiologId.toString().trim(),
                "job_id": job_id.trim(),
                "user_id": user_id.trim(),          
                "name": userNameArr,
                "last_message_time": new Date().getTime(),
                "last_message_type": 0,
                "last_message_sender_id": user_id.trim(),
                "last_message": lastMessageArr,
                "last_message_id": '',
                "unread_count": unread_count,
                "block_status": blockStatus,
                "clear_chat_time": clearChatTime,
                "user_name":user_name,
                "job_pic":company_pic,
                "pic":picArr,
                "company_name":company_name
              });           
              /////////
              
              let dialogArr = {}
              dialogArr[chatDiologId] = chatDiologId;
              var chatDialog11212 = this.db.object(`${this.firebaseUsers}/${user_id}`).update({
                  "chat_dialog_ids" : dialogArr
              });
              var chatDialog112= this.db.object(`${this.firebaseUsers}/${job_id}`).update({
                  "chat_dialog_ids" : dialogArr
              });   
              ///////////////
              this.router.navigateByUrl('message/message-detail/' +job_id);        
            } else {
              this.router.navigateByUrl('message/message-detail/' +job_id);
          }
    });
  }
}